export default () => ({
    popoverContent: {
        maxWidth: 280,
        padding: 4,
    },
    popoverItem: {
        display: 'block',
        marginTop: 4,
    },
    summaryChip: {
        maxWidth: '100%',
        minWidth: 0,
        display: 'inline-flex',
        overflow: 'hidden',
        verticalAlign: 'middle',
    },
    summaryChipWrapper: {
        minWidth: 0,
        maxWidth: '100%',
        overflow: 'hidden',
    },
    summaryChipText: {
        minWidth: 0,
        flex: '1 1 auto',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    summaryChipIcons: {
        flexShrink: 0,
    },
});
